<script lang="ts">
  let { status }: { status: string | null } = $props();
  const map: Record<string, string> = {
    active: 'bg-emerald-100 text-emerald-700',
    inactive: 'bg-red-100 text-red-700',
    none: 'bg-gray-100 text-gray-500',
    SUCCEEDED: 'bg-emerald-100 text-emerald-700',
    REFUNDED: 'bg-red-100 text-red-700',
    FAILED: 'bg-red-100 text-red-700',
    PENDING: 'bg-amber-100 text-amber-700',
  };
  const cls = $derived(status && map[status] ? map[status] : 'bg-gray-100 text-gray-500');
  const label = $derived(status ?? '—');
</script>

<span class="inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[10px] font-semibold tracking-[0.2px] ring-1 ring-inset ring-current/15 {cls}">
  <span class="inline-block h-1.5 w-1.5 rounded-full bg-current opacity-80"></span>
  {label}
</span>
